<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="700px"
  >
    <v-card v-if="!result">
      <v-card-title>
        <span class="text-h5">Новый гостевой пропуск</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-autocomplete
            v-model="form.place_id"
            :items="places"
            label="Место"
            :rules="[v => !!v || 'Обязательное поле']"
            outlined
            dense
            no-data-text="Нет мест"
            required
          />
          <v-text-field
            v-model="form.visitor_name"
            label="Имя посетителя"
            :rules="[v => !!v || 'Обязательное поле']"
            outlined
            dense
            required
          />
          <v-text-field
            v-model="form.purpose"
            label="Цель визита"
            outlined
            dense
          />
          <skud-date-field
            v-model="form.valid_from"
            label="Действует с"
            with-time
            :rules="[v => !!v || 'Обязательное поле']"
          />
          <skud-date-field
            v-model="form.valid_to"
            label="Действует по"
            with-time
            :rules="[v => !!v || 'Обязательное поле']"
          />
          <v-text-field
            v-model="form.host_subject_ref"
            label="Принимающий субъект"
            outlined
            dense
          />
          <skud-point-select
            v-model="form.points"
            :place-id="form.place_id"
            label="Точки прохода"
            :rules="[v => v.length > 0 || 'Укажите хотя бы одну точку']"
          />
          <v-select
            v-model="form.channel"
            label="Канал"
            :items="channels"
            outlined
            dense
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary darken-1"
          outlined
          rounded
          small
          class="ml-2 mb-2"
          :loading="loading"
          @click="submit()"
        >
          <span class="mx-4">Создать</span>
        </v-btn>
        <v-btn
          color="secondary darken-1"
          outlined
          rounded
          small
          class="ml-2 mb-2"
          @click="show = false"
        >
          <span class="mx-4">Отмена</span>
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <v-card-title>
        <span class="text-h5">Гостевой пропуск создан</span>
      </v-card-title>
      <v-card-text class="text-center">
        <div class="text-h4 mb-3">
          {{ result.code }}
        </div>
        <img
          v-if="result.qr_png_url"
          :src="result.qr_png_url"
          style="max-width: 240px"
          alt="QR гостевого пропуска"
        >
        <div class="mt-3">
          Проходов: {{ result.uses_left }} из {{ result.uses_total }}
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary darken-1"
          outlined
          rounded
          small
          class="ml-2 mb-2"
          @click="done()"
        >
          <span class="mx-4">Готово</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Диалог создания гостевого пропуска. После успеха показывает код + QR,
// закрытие результата — событие saved (список перезагружается).
import moment from 'moment'
import { SkudGuestService } from '@/views/skud/shared/services/skud-guest-service'
import { loadPlaces } from '@/views/skud/shared/services/skud-places-service'
import SkudPointSelect from '@/views/skud/components/SkudPointSelect.vue'
import SkudDateField from '@/views/skud/components/SkudDateField.vue'

export default {
  name: 'SkudGuestCreateDialog',
  components: {
    SkudPointSelect,
    SkudDateField
  },
  data: () => ({
    svc: null,
    show: false,
    loading: false,
    result: null,
    request_id: null,
    places: [],
    channels: [
      { value: 0, text: 'Личный кабинет' },
      { value: 2, text: 'Пост охраны' }
    ],
    form: {
      place_id: null,
      visitor_name: '',
      purpose: '',
      valid_from: '',
      valid_to: '',
      host_subject_ref: '',
      points: [],
      channel: 0
    }
  }),
  mounted () {
    this.svc = new SkudGuestService()
    loadPlaces().then(list => { this.places = list })
  },
  methods: {
    open () {
      this.result = null
      this.request_id = crypto.randomUUID()
      this.form = {
        place_id: this.$store.state.skud_place || null,
        visitor_name: '',
        purpose: '',
        valid_from: '',
        valid_to: '',
        host_subject_ref: '',
        points: [],
        channel: 0
      }
      this.show = true
    },
    async submit () {
      if (!this.$refs.form.validate()) return
      this.loading = true
      const body = {
        request_id: this.request_id,
        place_id: String(this.form.place_id),
        channel: this.form.channel,
        visitor_name: this.form.visitor_name,
        valid_from: moment(this.form.valid_from).toISOString(),
        valid_to: moment(this.form.valid_to).toISOString(),
        points: this.form.points
      }
      if (this.form.purpose) body.purpose = this.form.purpose
      if (this.form.host_subject_ref) body.host_subject_ref = this.form.host_subject_ref
      const r = await this.svc.createGuest(this.form.place_id, body)
      this.loading = false
      if (r.ok) {
        this.result = r.data
      } else {
        this.$store.commit('snackbar', r.error || 'Ошибка при создании пропуска')
      }
    },
    done () {
      this.show = false
      this.$emit('saved')
    }
  }
}
</script>
